import { storage } from '../../utils'
import React, { Component, PropTypes } from 'react'
import { Link, browserHistory } from 'react-router'
import Dialog from '../dialog'
import { formHandler, TextInput, Button } from '../ui'

export default class ForgotPassword extends Component {
    static displayName = 'ForgotPassword'

    static propTypes = {
        account: PropTypes.shape({
            forgot_password_errors: PropTypes.object.isRequired,
            forgot_password_message: PropTypes.string,
        }).isRequired,
        actions: PropTypes.shape({
            forgotPassword: PropTypes.func.isRequired,
            forgotPasswordTryAgain: PropTypes.func.isRequired,
        }).isRequired,
        appState: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
        }).isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            data: {},
        }

        this.updateValue = formHandler.updateValue.bind(this)
    }

    componentWillMount() {
        if (storage.getItem('authToken')) {
            browserHistory.push('/')
        }
    }

    _handleTryAgain = (e) => {
        e.preventDefault()

        this.setState({ data: {} })

        this.props.actions.forgotPasswordTryAgain()
    }

    forgotPassword = () => {
        this.props.actions.forgotPassword(this.state.data)
    }

    render() {
        const { forgot_password_message, forgot_password_errors: errors } = this.props.account

        const header = (
            <div className="logo">
                <img alt="" src="/img/hayden-logo.png" width="200" />
            </div>
        )

        const subFooter = (
            <div className="text-center">
                <p>Remember your password? <Link to="/sign-in">Sign in</Link></p>
            </div>
        )

        if (forgot_password_message === 'PASSWORD_RESET') {
            return (
                <Dialog
                    allowClose={ false }
                    background={ false }
                    header={ header }
                    open
                    size="small"
                    subFooter={ subFooter }
                >
                    <h4 className="align-center">Forgot password?</h4>
                    <p className="align-center">
                        Your request has been submitted.
                        Please check your inbox.
                    </p>
                    <p className="align-center">
                        <a href="#" onClick={ this._handleTryAgain }>Try again</a>
                    </p>
                </Dialog>
            )
        }

        return (
            <Dialog
                allowClose={ false }
                background={ false }
                header={ header }
                open
                size="small"
                subFooter={ subFooter }
            >
                <h4 className="align-center">Forgot password?</h4>
                <p className="align-center">
                    Please enter your email below. If we find it in our database,
                    we will send you a reset link.
                </p>

                { errors.non_field_errors &&
                    <div className="alert alert--error">
                        { errors.non_field_errors.map((item, index) => (
                            <div key={ index }>{ item }</div>
                        )) }
                    </div>
                }

                <TextInput
                    error={ errors.email }
                    name="email"
                    placeholder="Email"
                    type="email"
                    updateValue={ this.updateValue }
                    value={ this.state.data.email }
                />
                <Button
                    fullWidth
                    loading={ this.props.appState.loading }
                    onClick={ this.forgotPassword }
                    status="primary"
                >
                    Reset password
                </Button>
            </Dialog>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/account/forgot_password.js